import { render } from "./PageSucess.vue?vue&type=template&id=3e9248f6&scoped=true"
import script from "./PageSucess.vue?vue&type=script&lang=js"
export * from "./PageSucess.vue?vue&type=script&lang=js"

import "./PageSucess.vue?vue&type=style&index=0&id=3e9248f6&scoped=true&lang=css"

import exportComponent from "/Users/rhylton/Sites/projeto-obras/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9248f6"]])

export default __exports__